import { impersonateSource, requiresAuth, requiresTerms, impersonateTarget } from "@/middleware";

const HomeView = () => import("./HomeView.vue");

const homeRoutes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
    meta: {
      middleware: [requiresAuth, requiresTerms, impersonateSource, impersonateTarget]
    }
  }
];

export default homeRoutes;
